import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LearningPackageStudyProgressResponseDto} from '../../types/LearningPackageStudyProgressResponseDto';
import {EnvironmentService} from '../EnvironmentService';
import {LearningProgressHistoryResponseDto} from './api-types/LearningProgressHistoryResponseDto';
import {firstValueFrom, Observable} from 'rxjs';
import {TimePeriodMode} from './api-types/TimePeriodMode';
import {LearningPackageInsightsDetailsResponseDto} from './api-types/LearningPackageInsightsDetailsResponseDto';
import {LearningPackageInsightsQuestionsResponseDto} from './api-types/LearningPackageInsightsQuestionsResponseDto';
import {
    LearningPackageInsightsSkillsProfileResponseDto
} from './api-types/LearningPackageInsightsSkillsProfileResponseDto';
import {LearningPackageInsightsTopicsResponseDto} from './api-types/LearningPackageInsightsTopicsResponseDto';

@Injectable({
    providedIn: 'root'
})
export class StudyProgressRessource {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    public async getLearnerStudyProgress(msteamsId: string): Promise<LearningPackageStudyProgressResponseDto[]> {
        return firstValueFrom(this.http.get<LearningPackageStudyProgressResponseDto[]>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress`,
            {params: {msteamsid: msteamsId}}));
    }

    public async getLearnerStudyProgressForLearn(learnerId?: string): Promise<LearningPackageStudyProgressResponseDto[]> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return firstValueFrom(this.http.get<LearningPackageStudyProgressResponseDto[]>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress`, options));
    }

    public getLearnerLearningProgressHistory(learningPackageId: string, msteamsId: string, timePeriodMode: TimePeriodMode): Observable<LearningProgressHistoryResponseDto> {
        return this.http.get<LearningProgressHistoryResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress/${learningPackageId}/insights/learning-progress`,
            {params: {msteamsid: msteamsId, timePeriodMode: timePeriodMode}});
    }

    public getLearnerLearningProgressHistoryForLearn(learningPackageId: string, timePeriodMode: TimePeriodMode, learnerId?: string): Observable<LearningProgressHistoryResponseDto> {
        const options: {params: {timePeriodMode: TimePeriodMode; learnerid?: string}} = learnerId !== undefined ? {
            params: {
                timePeriodMode: timePeriodMode,
                learnerid: learnerId
            }
        } : {params: {timePeriodMode: timePeriodMode}};
        return this.http.get<LearningProgressHistoryResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress/${learningPackageId}/insights/learning-progress`, options);
    }

    public getLearnerLearningProgressInsightDetails(learningPackageId: string, msteamsId: string): Observable<LearningPackageInsightsDetailsResponseDto> {
        return this.http.get<LearningPackageInsightsDetailsResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress/${learningPackageId}/insights/details`,
            {params: {msteamsid: msteamsId}});
    }

    public getLearnerLearningProgressInsightDetailsForLearn(learningPackageId: string, learnerId?: string): Observable<LearningPackageInsightsDetailsResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return this.http.get<LearningPackageInsightsDetailsResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress/${learningPackageId}/insights/details`, options);
    }

    public getLearnerLearningProgressQuestionsDetails(learningPackageId: string, msteamsId: string): Observable<LearningPackageInsightsQuestionsResponseDto> {
        return this.http.get<LearningPackageInsightsQuestionsResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress/${learningPackageId}/insights/questions`,
            {params: {msteamsid: msteamsId}});
    }

    public getLearnerLearningProgressInsightQuestionsForLearn(learningPackageId: string, learnerId?: string): Observable<LearningPackageInsightsQuestionsResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return this.http.get<LearningPackageInsightsQuestionsResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress/${learningPackageId}/insights/questions`, options);
    }

    public getLearnerLearningProgressInsightSkillsProfile(learningPackageId: string, msteamsId: string): Observable<LearningPackageInsightsSkillsProfileResponseDto> {
        return this.http.get<LearningPackageInsightsSkillsProfileResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress/${learningPackageId}/insights/skills`,
            {params: {msteamsid: msteamsId}});
    }

    public getLearnerLearningProgressInsightSkillsProfileForLearn(learningPackageId: string, learnerId?: string): Observable<LearningPackageInsightsSkillsProfileResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return this.http.get<LearningPackageInsightsSkillsProfileResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress/${learningPackageId}/insights/skills`, options);
    }

    public getLearnerLearningProgressInsightTopics(learningPackageId: string, msteamsId: string): Observable<LearningPackageInsightsTopicsResponseDto> {
        return this.http.get<LearningPackageInsightsTopicsResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/study-progress/${learningPackageId}/insights/topics`,
            {params: {msteamsid: msteamsId}});
    }

    public getLearnerLearningProgressInsightTopicsForLearn(learningPackageId: string, learnerId?: string): Observable<LearningPackageInsightsTopicsResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return this.http.get<LearningPackageInsightsTopicsResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/study-progress/${learningPackageId}/insights/topics`, options);
    }
}
